const state = {
	projects: [],
	total: 0,
	filters: {},
	showFilters: true,
	statistics: [],
	areFiltersLoaded: false,
	mobileDisplayPixels: 600
}

const getters = {
	getSearchByFilters: (state) => (fieldName) => {
		return state[fieldName];
	},
	getFilterOptionsByType: (state) => (filterName) => {
		return state.filters[filterName];
	},
	getSelectedFilters: (state) => (urlParams) => {
		let filterParams = Object.keys(urlParams)
			.filter(param =>
				param !== 'text'
				&& param !== 'sort'
				&& param !== 'language'
				&& param !== 'page'
				&& param !== 'size'
				&& param !== 'publicationDates'
				&& param !== 'saverId'
				&& !param.startsWith("sub"));

		let subFilterParams = Object.keys(urlParams)
			.filter(param => param.startsWith("sub"));

		let matches = [];

		filterParams.forEach(key => {
			let mainFiltersId = urlParams[key].toString().length > 0
				? urlParams[key].toString().split(',').map(id => Number(id))
				: [];

			mainFiltersId.forEach(id => {
				addMainFilterToSelected(key, id);
			});
		});

		function addMainFilterToSelected(key, id) {
			let filter = state.filters[key].find(filter => filter.id === id);
			matches.push(filter);

			if (filter.subOptions) {
				subFilterParams.forEach(param => {
					let subFiltersIds = urlParams[param]?.toString().split(',').map(id => Number(id)) || [];
					subFiltersIds.forEach(subFilterId => {
						addSubFilterToSelected(filter, subFilterId);
					})
				})
			}
		}

		function addSubFilterToSelected(filter, subFilterId) {
			let subOption = {...filter.subOptions.find(subOption => subOption.id === subFilterId)};
			if (subOption && subOption.translations) {
				subOption.filterId = filter.id;
				subOption.filterType = filter.filterType;
				subOption.isSubOption = true;
				matches.push(subOption);
			}
		}

		return matches;
	}
}

const actions = {
	setSearchByFilters({commit}, {fieldName, value}) {
		commit('changeSearchByFilters', {fieldName, value});
	},
	setSearchByFiltersNextPage({commit}, {fieldName, value}) {
		commit('changeSearchByFiltersForNextPage', {fieldName, value});
	},
	setSingleFilter({commit}, {filterType, value}) {
		commit('changeFilterType', {filterType, value});
	},
}

const mutations = {
	changeSearchByFilters(state, {fieldName, value}) {
		state[fieldName] = value;
	},
	changeSearchByFiltersForNextPage(state, {fieldName, value}) {
		state[fieldName].push(...value);
	},
	changeFilterType(state, {filterType, value}) {
		state.filters[`${filterType}`] = value;
	}
}

export default {state, getters, actions, mutations};
